import axios from 'axios';
// 基本参数
//const web= {
////	apiPath: 'http://10.32.5.106/pre/',
////	apiPath: 'http://cms.pure-crystal.cn/',
////apiPath:'http://218.56.8.70:8132/tianti-module-interface/pre'	,
//apiPath: 'http://192.168.1.172:81/pre/',
//picPath: 'http://218.56.8.70:8132/tianti-module-admin',
//filePath: 'http://218.56.8.70:8132/tianti-module-admin'
//};
const web= {
//	apiPath: 'http://192.168.1.172:81/pre',     // 在生产环境中，需要在前端配置Nginx反向代理，将 www.weihaiedu.cn/pre/ 代理到 10.32.5.106/pre/
	apiPath: 'http://cms.pure-crystal.cn/pre'
};
// ajax 通用配置
web.api= axios.create({
  baseURL: web.apiPath
});
// 添加响应拦截器
web.api.interceptors.response.use(res=>{
  return res.data;
});
/*
基本调用方法:
http://218.56.8.70:8132/tianti-module-interface/pre/jydt?bg=0&count=8
语法：web.http.get('/jydt',{params:{bg:0, count:8}}).then(res=>{...}).catch(err=>{...});

http://218.56.8.70:8132/tianti-module-interface/pre/mkctd/count
语法：web.http.get('/mkctd/count').then(res=>{...}).catch(err=>{...});

*/
export default web;



// WEBPACK FOOTER //
// ./src/assets/js/web.js